import { jsx as r } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import { Input as m } from "../Input/Input.js";
const i = p((t, o) => /* @__PURE__ */ r(m, { ...t, type: "text", ref: o }));
export {
  i as TextInput
};
